import type { MobType } from "@mmotdg/shared";
import * as THREE from "three";

export const MOB_COLORS: Record<MobType, number> = {
  grunt: 0xa67c52,
  runner: 0xe8c547,
  tank: 0x7c4a4a,
  flyer: 0x9b6acf,
  armored: 0x4a6b8a,
  swarm: 0x6ec98a,
  boss: 0xd24d4d,
};

export const MOB_GEOMETRY_FACTORIES: Record<MobType, () => THREE.BufferGeometry> = {
  grunt: () => new THREE.BoxGeometry(0.4, 0.5, 0.4),
  runner: () => new THREE.ConeGeometry(0.25, 0.6, 6),
  tank: () => new THREE.BoxGeometry(0.6, 0.5, 0.6),
  flyer: () => new THREE.OctahedronGeometry(0.35, 0),
  armored: () => new THREE.CylinderGeometry(0.35, 0.35, 0.55, 6),
  swarm: () => new THREE.SphereGeometry(0.18, 8, 6),
  boss: () => new THREE.DodecahedronGeometry(0.7, 0),
};

export function createMobBodyGeometry(type: MobType): THREE.BufferGeometry {
  const factory = MOB_GEOMETRY_FACTORIES[type] ?? MOB_GEOMETRY_FACTORIES.grunt;
  return factory();
}

export function createMobBodyMaterial(type: MobType): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({
    color: MOB_COLORS[type] ?? 0xffffff,
    roughness: 0.6,
    metalness: 0.1,
  });
}
